import React from "react";

function formatShortMeridiemTime(value) {
    if (!value) return "--";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "--";

    const formatted = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).format(date);

    return formatted.replace(/\s*([AP])M$/i, "$1");
}

const tooltipStyle = {
    background: "#ffffff",
    border: "1px solid #d7e7f8",
    borderRadius: "10px",
    padding: "8px 10px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
};

const labelStyle = {
    fontWeight: 700,
    marginBottom: "4px",
    color: "#12324f",
};

const lineStyle = {
    margin: 0,
    fontSize: "0.92rem",
    color: "#20374d",
};

export default function ValetActivityTooltip({ active, payload, label }) {
    if (!active || !payload || !payload.length) return null;

    const datum = payload[0]?.payload || {};
    const parkedEntry = payload.find((entry) => String(entry?.name || "").toLowerCase() === "parked");
    const retrievedEntry = payload.find((entry) => String(entry?.name || "").toLowerCase() === "retrieved");
    const parkedValue = parkedEntry ? parkedEntry.value : 0;
    const retrievedValue = retrievedEntry ? retrievedEntry.value : 0;

    return (
        <div style={tooltipStyle}>
            <div style={labelStyle}>{label}</div>
            <p style={lineStyle}>Parked: {parkedValue}</p>
            <p style={lineStyle}>First: {formatShortMeridiemTime(datum.firstParkTransactionTime)}</p>
            <p style={lineStyle}>Last: {formatShortMeridiemTime(datum.lastParkTransactionTime)}</p>
            <p style={lineStyle}>Retrieved: {retrievedValue}</p>
            <p style={lineStyle}>First: {formatShortMeridiemTime(datum.firstRetrieveTransactionTime)}</p>
            <p style={lineStyle}>Last: {formatShortMeridiemTime(datum.lastRetrieveTransactionTime)}</p>
        </div>
    );
}
